<template>
  <div>
    <el-popover
      popper-class="gourp-edit"
      style="padding: 0px"
      placement="bottom-start"
      width="200"
      trigger="click"
      v-model="isPopoverShow"
      @click.native.stop
      @show="triggerPopShow"
    >
      <ul>
        <li @click="addGoods" v-if="group.id !== 0">添加商品</li>
        <li v-if="group.id !== 0 && group.group_type !== 0" @click="editGroup">编辑分组</li>
        <template v-if="level == 1 && group.group_type != 0">
          <li v-if="isCanAddNewGroup" @click="addGroup">{{ '添加子分组' }}</li>
          <li
            v-else
            style="cursor: not-allowed; color: #ddd;"
          >{{ group.id === 0 ? `添加子分组(最多${allGroup.length}个)` : '添加子分组(最多5个)' }}</li>
        </template>
      </ul>
      <i slot="reference" class="iconfont icongengduoda"></i>
      <make-group ref="makeGroup" :group="group" :groupId="groupId" :secondGroupId="secondGroupId" :allGroup="allGroup" :level="level"></make-group>
    </el-popover>
    <i ref="closeReference"></i>
  </div>
</template>

<script lang="ts">
import {
  ref,
  createComponent,
  computed,
  onBeforeMount,
  onBeforeUnmount,
} from "@vue/composition-api";
import MakeGroup from "./make_group.vue";
import event from "@/utils/event";
import { editionJudge } from "../../../../utils/editionJudge";
import { openRenewMessage } from "../../../../utils/system";

export default createComponent<{
  group: any;
  allGroup: any[];
  level: number;
  groupId: number
  secondGroupId: number
}>({
  props: {
    group: {},
    allGroup: Array,
    groupId: Number,
    secondGroupId: Number,
    level: Number,
  },
  setup(props, ctx) {
    const isPopoverShow = ref(false);
    let me;

    onBeforeMount(() => {
      me = Symbol("GROUP_POPPER");
      event.$on("GROUP_POPPER_SHOW", handlePopShow);
    });

    onBeforeUnmount(() => {
      event.$off("GROUP_POPPER_SHOW", handlePopShow);
    });

    function handlePopShow(who) {
      if (who !== me) {
        closeSelf();
      }
    }

    function editGroup() {
      (ctx.refs.makeGroup as any).open({
        mode: "update",
        callback: (type) => {
          ctx.emit("groupChange", type);
        },
      });
      closeSelf();
    }

    function addGroup() {
      const flag = judgeIsEnable();
      if (!flag) {
        return;
      }

      (ctx.refs.makeGroup as any).open({
        mode: "create",
        callback: (type) => {
          ctx.emit("groupChange", type);
        },
      });
      closeSelf();
    }

    function judgeIsEnable() {
      if (editionJudge.isBiaoZhun && !editionJudge.isShiYong) {
        if (props.group.id === 0) {
          if (props.allGroup.length >= 5) {
            openRenewMessage(
              "标准版最多可添加5个一级分组，如需添加更多分组，请升级为专业版/旗舰版"
            );
            return false;
          }
        } else {
          openRenewMessage(
            "标准版无法添加二级分组，如需添加，请升级至更高版本"
          );
          return false;
        }
      }

      if (editionJudge.isZhuanYe || editionJudge.isShiYong) {
        if (props.group.id === 0) {
          if (props.allGroup.length >= 12) {
            openRenewMessage(
              editionJudge.isRealZhuanYe
                ? "专业版最多可添加12个一级分组，如需添加更多分组，请升级为旗舰版"
                : "试用版最多可添加12个一级分组，如需添加更多分组，请购买正式版"
            );
            return false;
          }
        } else {
          const target = props.allGroup.find(
            (value) => +value.id === +props.group.id
          );
          if (target && target.secondary_group.length >= 3) {
            openRenewMessage(
              editionJudge.isRealZhuanYe
                ? "专业版最多可添加3个二级分组，如需添加更多分组，请升级至旗舰版"
                : "试用版最多可添加3个二级分组，如需添加更多分组，请购买正式版"
            );
            return false;
          }
        }
      }

      return true;
    }

    const isCanAddNewGroup = computed(() => {
      if (+props.group.id === 0) {
        ctx.root.$nextTick(() => {});
        if (editionJudge.isBiaoZhun && props.allGroup.length >= 5) {
          return false;
        } else {
          if (
            (editionJudge.isRealZhuanYe || editionJudge.isShiYong) &&
            props.allGroup.length >= 12
          ) {
            return false;
          } else {
            if (editionJudge.isQiJian && props.allGroup.length >= 20) {
              return false;
            } else {
              return true;
            }
          }
        }
      } else {
        const target = props.allGroup.find(
          (value) => +value.id === +props.group.id
        );
        if (target) {
          if (target.secondary_group.length < 5) {
            return true;
          } else {
            return false;
          }
        }
        return false;
      }
    });

    function addGoods() {
      if (+props.level === 2) {
        console.log('2222')
        ctx.emit("addGoods", props.groupId, props.secondGroupId,props.group.group, props.group.id);
      } else {
        ctx.emit("addGoods", props.groupId,props.group.id);
      }
      closeSelf();
    }

    function closeSelf() {
      isPopoverShow.value = false;
    }

    function triggerPopShow() {
      event.$emit("GROUP_POPPER_SHOW", me);
    }

    return {
      isPopoverShow,
      editGroup,
      addGroup,
      addGoods,
      isCanAddNewGroup,
      triggerPopShow,
    };
  },

  components: {
    MakeGroup,
  },
});
</script>

<style lang="scss">
.gourp-edit {
  padding: 6px 0px !important;
  width: 108px !important;

  ul {
    li {
      padding-left: 8px;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      color: #333333;
      cursor: pointer;

      &:hover {
        background: #f5f5f5;
      }
    }
  }
}

.icongengduoda {
  // display: none;
  color: #888888;
  margin-right: 8px;
  font-size: 14px;
}
</style>
